import { IBaseVraagboomResultaat } from './base.vraagboom.resultaat';

export class VraagboomSelectieResultaat implements IBaseVraagboomResultaat {
  code: string;
  titel: string;
  omschrijving: string;

  constructor(code: string, titel: string, omschrijving: string) {
    this.code = code;
    this.titel = titel;
    this.omschrijving = omschrijving;
  }

  get displayValue() : string {
    if (this.titel)
      return this.omschrijving ? this.titel + " " + this.omschrijving : this.titel;

    return this.omschrijving;
  }
}
